import "react-app-polyfill/ie11";
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import i18n from "./components/helper/i18nInitialization";

//import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

//registerServiceWorker();
i18n.init().then(
  () => {
    ReactDOM.render(
      <BrowserRouter basename={baseUrl}>
        <App />
      </BrowserRouter>,
      rootElement);
    });